module.exports = __webpack_public_path__ + "img/findworka-logo.6b8fb5d3.png";